import { render, staticRenderFns } from "./DupilumabeWarning.vue?vue&type=template&id=5e163c5c&"
import script from "./DupilumabeWarning.vue?vue&type=script&lang=js&"
export * from "./DupilumabeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports